<template>
	<el-container>
		<el-aside>
			<el-header style="background-color:#545c64;display: flex;align-items: center;justify-content: center;padding:0;">
				<!-- <span style="color:white;" v-if="isCollapse">汲悟科技</span> -->
				<div class="main-logo" style="width:30px;height:30px;"></div>
				<span style="color:white;margin-left:10px;" v-show="!isCollapse">汲悟科技</span>
			</el-header>
			<el-menu text-color="#fff" background-color="#545c64" active-text-color="#ffd04b" :router="true"
				:unique-opened="true" :collapse="isCollapse" :collapse-transition="false">
				
				<el-submenu v-for="menu, i in menus" :index="menu.index" :key="i">
					<template slot="title">
						<i :class="menu.icon"></i>
						<span>{{menu.label}}</span>
					</template>
					<el-menu-item v-for="childMenu, j in menu.child" :index="childMenu.index" :key="j">
						<el-badge :value="cargo_agent_status_2_amout" v-if="childMenu.index === '/admin/partner' && cargo_agent_status_2_amout > 0" class="badge-item" :max="99">
							{{childMenu.label}}
						</el-badge>
						<span v-else>{{childMenu.label}}</span>
					</el-menu-item>
				</el-submenu>
			</el-menu>
		</el-aside>
		<el-container>
			<el-header class="container-header">
				<el-popover placement="bottom" width="270" trigger="hover" popper-class="account-popover">
					<div slot="reference" style="color:white;font-size:80%;">{{user?.user?.email || '我的'}}</div>
					<div class="infos">
						<div style="border-bottom: 1px solid #f3f3f3;">
							<!-- <div :style="accountIdStyles">
								<span style="flex-shrink:0;">账号 ID: {{user?.user?.id}}</span>
								<i style="margin-left:10px;cursor:pointer;flex-shrink: 0;"
									class="el-icon-document-copy text-primary" @click="copyItem('id')"><span
										style="flex-shrink: 1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
										v-show="copied.id">已复制</span></i>
							</div> -->
							<div :style="accountIdStyles" v-if="user?.user?.referrerCode">
								<span style="flex-shrink:0;">帐号编码: {{user?.user?.referrerCode}}</span>
								<i style="margin-left:10px;cursor:pointer;flex-shrink: 0;"
									class="el-icon-document-copy text-primary" @click="copyItem('referrerCode')"><span
										style="flex-shrink: 1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
										v-show="copied.referrerCode">已复制</span></i>
							</div>
							<div :style="accountIdStyles" v-else>
								<span style="flex-shrink:0;">账号: {{user?.user?.username}}</span>
							</div>
							<div :style="accountIdStyles" v-if="rateInfo">
								<span style="flex-shrink:0;">当前等级: {{rateInfo?.name}}</span>
							</div>
							<div :style="accountIdStyles" v-if="rateInfo">
								<span style="flex-shrink:0;">服务费率: 购买年单-{{rateInfo?.orderRate}}%,代申报-{{rateInfo?.requestRate}}%</span>
							</div>
							<div :style="accountIdStyles">
								<span style="cursor:pointer;" @click="dialog.pwd=true"><i class="el-icon-edit mr-1"></i>修改密码</span>
							</div>
						</div>
						<div :style="accountBtnStyles">
							<el-button class="w-100" @click="logout()">登出</el-button>
						</div>
					</div>
				</el-popover>
			</el-header>
			<el-main>
				<router-view></router-view>
			</el-main>
			<el-footer style="display:none;">Footer</el-footer>
		</el-container>
		<el-dialog title="提示" :visible.sync="dialog.expired" :show-close="false" :close-on-click-modal="false">
			<span>您登录口令已过期</span>
			<div slot="footer" class="dialog-footer">
				<el-button @click="logout()" :disabled="loading">退出登录</el-button>
				<el-button type="primary" @click="refreshToken()" :disabled="loading">刷新口令</el-button>
			</div>
		</el-dialog>
		<el-dialog title="修改密码" :visible.sync="dialog.pwd" :show-close="false" :close-on-click-modal="false">
			<el-form ref="pwdForm" :model="pwdForm" :rules="pwdFormRules" label-width="80px">
				<el-form-item label="旧密码" prop="oldPassword">
					<el-input v-model="pwdForm.oldPassword" show-password />
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input v-model="pwdForm.newPassword" show-password />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialog.pwd=false" :disabled="loading">取 消</el-button>
				<el-button type="primary" @click="updatePwd()" :disabled="loading">确 认</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
	import {
		EventBus
	} from '@/utils/eventBus';
	import {
		mapGetters
	} from 'vuex'
	export default {
		name: 'DashboardLayout',
		data() {
			return {
				showErr: false,
				dialog: {
					expired: false,
					pwd: false
				},
				loading: false,
				copied: {
					id: false,
					referrerCode: false
				},
				isCollapse: false,
				cargo_agent_status_2_amout: 0,
				loopInterval: null,
				rateInfo: null,
				pwdForm: {
					oldPassword: "",
					newPassword: ""
				},
				pwdFormRules: {
					oldPassword: [{
							required: true,
							message: "请输入旧密码",
							trigger: "blur"
						},
						{
							min: 6,
							max: 16,
							message: "密码长度需为6-16位",
							trigger: "blur"
						},
					],
					newPassword: [{
							required: true,
							message: "请输入新密码",
							trigger: "blur"
						},
						{
							min: 6,
							max: 16,
							message: "密码长度需为6-16位",
							trigger: "blur"
						},
					]
				}
			}
		},
		created() {
			EventBus.$on('error-401', (message) => {
				this.dialog.expired = true
			})
			if (this.user?.user.type === 'ADMIN') {
				EventBus.$on('cargo-agent-status-2', (_) => {
					this.$store.dispatch('admin/partnerPage', {status: 2, pageNo: 1, pageSize: 1})
					.then(res => {
						const {total} = res
						this.cargo_agent_status_2_amout = total 
					})
				})
				// 初始化
				this.loopInterval = setInterval(() => {
					EventBus.$emit('cargo-agent-status-2', '1')
				}, 60 * 1000)
			}
		},
		watch: {
			'$route': {
				handler(newVal) {
					try {
						const { meta: { layout } } = newVal
						console.log(layout)
						this.$store.dispatch('ins/getRateInfo')
						.then(rateInfo => {
							this.rateInfo = rateInfo
						})
					} catch (e) {}
					console.log(newVal)
				},
				immediate: true
			},
			'dialog.pwd': {
				handler(newVal) {
					if (newVal) {
						this.$nextTick(() => {
							this.$refs.pwdForm.clearValidate()
						})
					} else {
						this.pwdForm = {
							newPassword: '',
							oldPassword: ''
						}
					}
				},
				immediate: true
			}
		},
		mounted() {
			window.addEventListener("resize", this.updateWindowWidth);
		},
		computed: {
			...mapGetters({
				user: 'system/user',
				menus: 'system/menus'
			}),
			accountIdStyles() {
				return {
					fontSize: '12px',
					padding: '5px 0',
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center'
				}
			},
			accountBtnStyles() {
				return {
					padding: '15px 0',
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center'
				}
			}
		},
		methods: {
			refreshToken() {
				this.loading = true
				const refreshToken = this.$store.state.system.user?.refreshToken
				if (refreshToken) {
					this.$store.dispatch('system/refreshToken', refreshToken)
						.then(user => {
							this.$store.commit('system/SET_USER', user)
							this.$nextTick(() => {
								window.location.reload()
							})
						})
						.catch(err => {
							const code = err?.code
							try {
								this.$message({
									type: 'error',
									message: err.msg
								})
							} catch (e) {}
							// 无效的刷新令牌
							if (code === 99999) {
								this.logout()
							}
						})
						.finally(() => {
							this.loading = false
						})
				} else {
					this.logout()
				}
			},
			logout() {
				this.$store.commit('system/SET_USER', null)
				this.$nextTick(() => {
					this.$router.replace(`/login?redirect_uri=${this.$route.path}`)
				})
			},
			handleSelect(key, keyPath) {
				if (typeof(this[key]) === 'function') {
					this[key]()
				}
			},
			copyItem(k) {
				const user = this.user?.user || {}
				const val = user[k]
				val && navigator.clipboard.writeText(val).then(() => {
					if (!this.copied[k]) {
						this.copied[k] = true
						setTimeout(() => {
							this.copied[k] = false
						}, 5000)
					}
				})
			},
			updateWindowWidth() {
				this.isCollapse = window.innerWidth < 1200
			},
			updatePwd() {
				this.$refs.pwdForm.validate(v => {
					if (v) {
						this.loading = true
						this.$store.dispatch('auth/updatePwd', this.pwdForm)
							.then(success => {
								this.$message({
									type: 'success',
									message: '修改成功'
								})
								this.dialog.pwd = false
							})
							.catch(err => {
								const code = err?.code
								try {
									this.$message({
										type: 'error',
										message: err.msg
									})
								} catch (e) {}
							})
							.finally(() => {
								this.loading = false
							})
					}
				})
			}
		},
		destroyed() {
			EventBus.$off('error-401')
			window.removeEventListener("resize", this.updateWindowWidth)
			EventBus.$off('cargo-agent-status-2')
			this.loopInterval && clearInterval(this.loopInterval)
		}
	}
</script>

<style lang="scss" scoped>
	// Varbiles
	$mobile: 768px;
	$tablet: 1000px;
	$aside-bg-color: #545c64;

	.el-container {
		height: 100vh;
	}

	.el-header,
	.el-footer {
		background-color: #B3C0D1;
		color: #333;
		text-align: center;
		line-height: 60px;
	}

	.container-header {
		text-align: right;
		padding: 0;
		background-color: #545c64;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		padding: 0 25px;
	}

	.el-aside {
		background-color: $aside-bg-color;
		width: 200px !important;
	}
	.el-aside:has(ul.el-menu.el-menu--collapse) {
		width: 63px !important;
	}

	.el-main {
		background-color: #E9EEF3;
	}
	.badge-item {
		/deep/ .el-badge__content.is-fixed {
			right: -5px !important;
			transform: translateX(100%) translateY(85%);
		}
	}
</style>